import {AbstractModel, DateConverter, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {ProjectActivity} from '../../project-misc/data/project/activity/project-activity';

@JsonObject('model.activity.LogisticSuggestion')
export class LogisticSuggestion extends AbstractModel {

  @JsonProperty([ProjectActivity], 'activities')
  activities?: ProjectActivity[];

  @JsonProperty(DateConverter, 'lastRunStart')
  lastRunStart?: Date;

  @JsonProperty(DateConverter, 'lastRunFinish')
  lastRunFinish?: Date;

  @JsonProperty(Boolean, 'stale')
  stale?: boolean;

  @JsonProperty(String, 'status')
  status?: string;
}
